import React, { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Box, Button, styled, TextField, Typography } from "@mui/material";
import { useCriticalActivitiesMutation, useFetchCoreActivityQuery } from "../../../services/roleReviewService";
import useAuth from "../../../hooks/useAuth";
import { Link, useParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const ErrorText = styled("div")`
  color: red;
  font-size: 12px;
  margin-top: 4px;
`;
const validationSchema = yup.object().shape({
  coreFocusAreas: yup
    .array()
    .of(
      yup.object().shape({
        subData: yup
          .array()
          .of(
            yup.object().shape({
              subTask: yup.string().required("Subtask is required"),
              timeSpent: yup
                .number()
                .typeError("Time Spent must be a valid number")
                .min(0, "Must be at least 0")
                .max(100, "Cannot exceed 100")
                .required("Time Spent is required"),
            })
          )
          .required("At least one Subtask is required"),
      })
    )
    .required("Core Focus Areas are required"),
});

const Step3 = ({ currentStep, onPrev, formData ,onNext}) => {
  const { users } = useAuth();
  // const userId = useParams();
  // const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  // const [isJwtUser, setIsJwtUser] = useState(false);
  
  const { id: param } = useParams();
  
  const [employeeId, setEmployeeId] = useState(null);
    useEffect(() => {
      if (users?.role === "manager") {
        if (param.includes(".")) {
          try {
            const decoded = jwtDecode(param); // Decode JWT token
            setEmployeeId(decoded?.user_id);
            // setIsJwtUser(true);  // Set employeeId in state
            console.log(decoded?.user_id); // Extract user ID from token
          } catch (error) {
            console.error("Invalid token:", error);
            setEmployeeId(null);
          }
        } else {
          setEmployeeId(param);
          // setIsJwtUser(false);  // If not a token, use the param as employee ID
        }
      } else {
        setEmployeeId(users?.user_id); // Use logged-in user ID for non-managers
      }
    }, [users, param]);
  console.log("employeeId",employeeId)
 
  // const navigate = useNavigate();
  const [createCriticalActivity] = useCriticalActivitiesMutation();
  const { data: fetchedActivities,refetch:fetchactivitiesdata} = useFetchCoreActivityQuery(employeeId);
  
  useEffect(() => {
    if (employeeId) {
      fetchactivitiesdata();
      console.log("fetchedActivities", fetchedActivities);
    } else {
      console.warn("Employee ID is not set. Cannot fetch activities.");
    }
  }, [employeeId, fetchactivitiesdata, fetchedActivities]);
  // const processedFormData = {
  //   ...formData,
  //   coreFocusAreas: formData.coreFocusAreas.map((focusArea) => ({
  //     ...focusArea,
  //     subData: focusArea.subData?.length > 0 ? focusArea.subData : [{ subTask: "", timeSpent: "" }],
  //   })),
  // };
  const processedFormData = {
    ...formData,
    coreFocusAreas: formData.coreFocusAreas.map((focusArea) => {
      // Find all activities related to the current coreFocusArea
      const relatedActivities = fetchedActivities?.data?.filter(
        (activity) => activity.core_focus_area_id === focusArea.id
      );

      // If related activities exist, map them to subData; otherwise, set empty fields
      return {
        ...focusArea,
        subData: relatedActivities?.length > 0
          ? relatedActivities.map((activity) => ({
              subTask: activity.area || "",  // Setting the "area" as "subTask"
              timeSpent: activity.importance || "" // Setting "importance" as "timeSpent"
            }))
          :  [
            { subTask: "", timeSpent: "" },
            { subTask: "", timeSpent: "" },
            { subTask: "", timeSpent: "" },
          ] // Default empty subtask if no related activity
      };
    })
  };
  

  const {
    register,
    handleSubmit,
    control,
    watch,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: processedFormData,
    resolver: yupResolver(validationSchema),
  });

  // Define useFieldArray for coreFocusAreas
  const { fields: coreFocusFields} = useFieldArray({
    control,
    name: "coreFocusAreas",
  });
  // useEffect(() => {
  //   if (fetchedActivities?.data) {
  //     console.log("Fetched Activities:", fetchedActivities.data);
  
  //     // Create a mapping to store activities grouped by core_focus_area_id
  //     const focusAreaMap = {};
  
  //     fetchedActivities.data.forEach((activity) => {
  //       // Find the corresponding core focus area index
  //       const focusAreaIndex = formData.coreFocusAreas.findIndex(
  //         (focusArea) => focusArea.id === activity.core_focus_area_id
  //       );
  
  //       if (focusAreaIndex >= 0) {
  //         // If the focus area is already mapped, push new data; otherwise, initialize array
  //         if (!focusAreaMap[focusAreaIndex]) {
  //           focusAreaMap[focusAreaIndex] = [];
  //         }
  //         focusAreaMap[focusAreaIndex].push({
  //           subTask: activity.area,
  //           timeSpent: activity.importance,
  //         });
  //       }
  //     });
  
  //     // Update the form state with all collected subData for each core focus area
  //     Object.keys(focusAreaMap).forEach((index) => {
  //       setValue(`coreFocusAreas.${index}.subData`, focusAreaMap[index]);
  //     });
  //   }
  // }, [fetchedActivities, formData.coreFocusAreas, setValue]);
  useEffect(() => {
    if (fetchedActivities?.data) {
      console.log("Fetched Activities:", fetchedActivities.data);
  
      const focusAreaMap = {};
  
      fetchedActivities.data.forEach((activity) => {
        const focusAreaIndex = formData.coreFocusAreas.findIndex(
          (focusArea) => focusArea.id === activity.core_focus_area_id
        );
  
        if (focusAreaIndex >= 0) {
          if (!focusAreaMap[focusAreaIndex]) {
            focusAreaMap[focusAreaIndex] = [];
          }
          focusAreaMap[focusAreaIndex].push({
            subTask: activity.area,
            timeSpent: activity.importance,
          });
        }
      });
  
      Object.keys(focusAreaMap).forEach((index) => {
        // Set only if no prefilled data exists
        if (!focusAreaMap[index] || focusAreaMap[index].length === 0) {
          focusAreaMap[index] = [
            { subTask: "", timeSpent: "" },
            { subTask: "", timeSpent: "" },
            { subTask: "", timeSpent: "" },
          ];
        }
        setValue(`coreFocusAreas.${index}.subData`, focusAreaMap[index]);
      });
  
      // Handle cases where coreFocusAreas have no activities and no prefilled data
      formData.coreFocusAreas.forEach((focusArea, index) => {
        const existingSubData = watch(`coreFocusAreas.${index}.subData`);
        if (!existingSubData || existingSubData.length === 0) {
          setValue(`coreFocusAreas.${index}.subData`, [
            { subTask: "", timeSpent: "" },
            { subTask: "", timeSpent: "" },
            { subTask: "", timeSpent: "" },
          ]);
        }
      });
    }
  }, [fetchedActivities, formData.coreFocusAreas, setValue, watch]);
  
  
  const onSubmit =async (data) => {
    let areaExceeds100 = false;

    coreFocusFields.forEach((field, index) => {
      const subTasks = getValues(`coreFocusAreas.${index}.subData`);
      const totalTimeForArea = subTasks.reduce(
        (subAcc, subTask) => subAcc + (Number(subTask.timeSpent) || 0),
        0
      );

      if (totalTimeForArea > 100) {
        //Alert message removed
        areaExceeds100 = true; //Set the flag to true
      }
      if (totalTimeForArea < 100) {
        //Alert message removed
        areaExceeds100 = true; //Set the flag to true
      }
    });

    if (areaExceeds100) {
      // Do not submit the form if there are any validation errors or if an area exceeds 100%
      return;
    }
  // if (isSubmitDisabled) return;
    try { 
      
      const payload = data.coreFocusAreas.flatMap(focusArea =>
              focusArea.subData.map(subTask => ({
                user_id: employeeId,
                core_focus_area_id: focusArea.id,
                area: subTask.subTask,
                importance: subTask.timeSpent,
              }))
            );
      
      await createCriticalActivity(payload);
      
      // console.log("Role review created successfully:", response);
      onNext(); // Proceed to the next step
    } catch (error) {
      console.error("Failed to create role review:", error);
      // Handle error (e.g., show an error message to the user)
    }

    // onNext();
  };
  const saveDataToBackend = async (data) => {
    const transformedData = data.coreFocusAreas.flatMap((focusArea) =>
      focusArea.subData.map((subTask) => ({
        user_id: employeeId,
        core_focus_area_id: focusArea.id,
        area: subTask.subTask,
        importance: subTask.timeSpent,
      }))
    );
  
    try {
      await createCriticalActivity(transformedData);
      console.log("Data saved successfully to backend");
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };
  const handlePrevious = async (data) => {
    try {
      await saveDataToBackend(data);
      onPrev(); // Move to the previous step after saving data
    } catch (error) {
      console.error("Error saving data before going back:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormMiddleBoxWrap
        sx={{
          paddingTop: "30px",
          paddingBottom: "0px",
          marginBottom: "0",
          boxShadow: "0",
          position: "relative",
          zIndex: "1",
        }}
      >
        <RowWrap>
          <Col12Wrap>
            <CustomHead>
             What are the critical activities that happen within each of the core focus areas you defined?
            </CustomHead>
            <FormLabelWrap
                    sx={{
                      fontSize: "20px",
                      color: "#7C7C7C",
                      letterSpacing: "0.3px",
                      marginBottom: "0px",
                    }}
                  >
                  Now please list, in order of importance, the critical activities that make up each core focus area listed below.Be sure that each “core focus area” totals to 100%. We’re looking for how your time in that segment of work is allocated. 
                  </FormLabelWrap>
                  <FormLabelWrap
                    sx={{
                      fontSize: "20px",
                      color: "#7C7C7C",
                      letterSpacing: "0.3px",
                      marginBottom: "10px",
                    }}
                  >
                    If needed, there is a short video to guide you.{" "}
                    <Link
                      to="https://youtu.be/MauV2Ui6arQ"
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{ color: "#1976d2", textDecoration: "underline", fontWeight: "bold" }}
                    >
                      Click here to watch video
                    </Link>
                  </FormLabelWrap>
          </Col12Wrap>
        </RowWrap>
      </FormMiddleBoxWrap>

      {coreFocusFields.map((field, index) => {
        // Define useFieldArray for each subData dynamically
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { fields: subFields, append: appendSubtask, remove: removeSubtask } = useFieldArray({
          control,
          name: `coreFocusAreas.${index}.subData`,
        });

        const totalTime = watch(`coreFocusAreas.${index}.subData`, []).reduce(
          (acc, subTask) => acc + Number(subTask.timeSpent || 0),
          0
        );

        return (
          <FormMiddleBoxWrap key={field.id} sx={{ paddingTop: "30px", paddingBottom: "50px" }}>
            <RowWrap>
              <Col12Wrap>
                <FormLabelWrap>{field.area}</FormLabelWrap>

                {subFields.map((subField, subIndex) => (
                  <Box
                    key={subField.id}
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      alignItems: "flex-start",
                      columnGap: "10px",
                      marginBottom: "10px",
                      position: "relative",
                    }}
                  >
                    <Box width={{ width: "calc(100% - 120px)" }}>
                      <CustomTextField
                        sx={{
                          "& .MuiInputBase-input": {
                            padding: "10px 20px",
                          },
                        }}
                        variant="outlined"
                        {...register(`coreFocusAreas.${index}.subData.${subIndex}.subTask`)}
                        placeholder="Subtask"
                      />
                      {errors?.coreFocusAreas?.[index]?.subData?.[subIndex]?.subTask && (
                        <ErrorText>
                          {errors?.coreFocusAreas?.[index]?.subData?.[subIndex]?.subTask?.message}
                        </ErrorText>
                      )}
                    </Box>
                    <Box sx={{ width: "100px" }}>
                      <CustomTextField
                        sx={{
                          "& .MuiInputBase-input": {
                            padding: "10px 20px",
                          },
                        }}
                        variant="outlined"
                        {...register(`coreFocusAreas.${index}.subData.${subIndex}.timeSpent`)}
                        placeholder="Time (%)"
                      />
                      {errors?.coreFocusAreas?.[index]?.subData?.[subIndex]?.timeSpent && (
                        <ErrorText>
                          {errors?.coreFocusAreas?.[index]?.subData?.[subIndex]?.timeSpent?.message}
                        </ErrorText>
                      )}
                    </Box>
                    <Box sx={{ width: "100px", display: "flex", justifyContent: "center" }}>
                      <CustomBtn
                        type="button"
                        onClick={() => removeSubtask(subIndex)}
                        variant="outlined"
                        sx={{
                          fontSize: "5px",
                          fontWeight: "600",
                          color: "#E75B5B",
                          borderColor: "#F0F0F0",
                          borderRadius: "7px",
                          background: "#F0F0F0",
                          position: "absolute",
                          top: "9px",
                          right: "-30px",
                          width: "25px",
                          height: "25px",
                          minWidth: "0",
                          padding: "6px",
                          "& svg": {
                            margin: "0",
                          },
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L15 15M15 1L1 15"
                            stroke="#E75B5B"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                        </svg>
                      </CustomBtn>
                    </Box>
                  </Box>
                ))}
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    columnGap: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <Box width={{ width: "calc(100% - 120px)" }}>
                    <CustomBtn
                      type="button"
                      onClick={() => appendSubtask({ subTask: "", timeSpent: "" })}
                      variant="outlined"
                      sx={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#1085AB",
                        borderColor: "#F0F0F0",
                        borderRadius: "7px",
                        background: "#F0F0F0",
                        maxWidth: "90px",
                        padding: "10px 10px",
                        "& svg": {
                          marginRight: "8px",
                        },
                      }}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.10767 1L8.10767 15"
                          stroke="#F28021"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                        <path
                          d="M1 8.18335L15 8.18335"
                          stroke="#F28021"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                      Add 
                    </CustomBtn>
                  </Box>
                  <Box sx={{ width: "100px" }}>
                       <FormLabelWrap
                        sx={{
                          fontSize: "16px",
                          fontWeight: "500",
                          textAlign: "center",
                          marginBottom: "0",
                        }}
                      >
                        {totalTime}%
                        {totalTime > 100 && (
  <ErrorText>Total percentage cannot exceed 100%!</ErrorText>
)}
{totalTime < 100 && (
  <ErrorText>Total percentage cannot under 100%!</ErrorText>
)}
                      </FormLabelWrap>
                    </Box>
                </Box>
              </Col12Wrap>
            </RowWrap>
          </FormMiddleBoxWrap>
        );
      })}
      <FormBtnBoxWrap>
           <RowWrap>
             <Col12Wrap sx={{ textAlign: "center" }}>
              <CustomBtn
            type="button"
            variant="outlined"
            sx={{
              marginRight: "10px", // Add spacing between buttons
              "& svg": { marginRight: "10px" },
            }}
            onClick={() => handlePrevious(getValues())} // Call the onPrev function on click
          >
            <svg
              width="15"
              height="16"
              viewBox="0 0 15 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 7C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9L14 7ZM0.292893 8.70711C-0.0976311 8.31658 -0.097631 7.68342 0.292893 7.29289L6.65685 0.928932C7.04738 0.538407 7.68054 0.538407 8.07107 0.928932C8.46159 1.31946 8.46159 1.95262 8.07107 2.34315L2.41421 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292893 8.70711ZM14 9L1 9L1 7L14 7L14 9Z"
                fill="white"
              />
            </svg>
            Previous
          </CustomBtn>
              <CustomBtn
              type="submit"
              variant="outlined"
              
              sx={{ "& svg": { 
                marginLeft: "10px" 
              },
             
              
            
            }}
             
            >
              Next
              <svg
                width="15"
                height="16"
                viewBox="0 0 15 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 7C0.447715 7 -4.82823e-08 7.44772 0 8C4.82823e-08 8.55228 0.447715 9 1 9L1 7ZM14.7071 8.70711C15.0976 8.31658 15.0976 7.68342 14.7071 7.29289L8.34315 0.928932C7.95262 0.538407 7.31946 0.538407 6.92893 0.928932C6.53841 1.31946 6.53841 1.95262 6.92893 2.34315L12.5858 8L6.92893 13.6569C6.53841 14.0474 6.53841 14.6805 6.92893 15.0711C7.31946 15.4616 7.95262 15.4616 8.34315 15.0711L14.7071 8.70711ZM1 9L14 9L14 7L1 7L1 9Z"
                  fill="white"
                />
              </svg>
            </CustomBtn>
            </Col12Wrap>
          </RowWrap>
        </FormBtnBoxWrap>
    </form>
  );
};

export default Step3;

const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "-15px",
  marginRight: "-15px",
}));
const Col12Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
}));
const FormMiddleBoxWrap = styled(Box)(() => ({
  padding: "50px 150px",
  background: "#ffffff",
  maxWidth: "1030px",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "16px",
  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
  "@media (max-width: 1199px)": {
    maxWidth: "100%",
    paddingLeft: "100px",
    paddingRight: "100px",
  },
  "@media (max-width: 991px)": {
    paddingLeft: "50px",
    paddingRight: "50px",
  },
  "@media (max-width: 575px)": {
    paddingLeft: "15px",
    paddingRight: "15px",
  },
}));
const FormBtnBoxWrap = styled(Box)(() => ({
  maxWidth: "1030px",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "30px",
  "@media (max-width: 1199px)": {
    maxWidth: "100%",
  },
}));
const FormLabelWrap = styled(Typography)(() => ({
  fontSize: "20px",
  fontWeight: "500",
  lineHeight: "1.445",
  color: "#000000",
  marginBottom: "10px",
}));
const CustomBtn = styled(Button)(() => ({
  width: "100%",
  fontSize: "22px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#F28021",
  borderColor: "#F28021",
  borderRadius: "10px",
  // padding: "19px 20px",
  // maxWidth: "300px",
  maxWidth: "150px",
  padding: "10px 15px",
  boxShadow: "none !important",
}));
const CustomTextField = styled(TextField)(() => ({
  width: "100%",
  border: "1px solid #DADADA",
  borderRadius: "7px",
  "& .MuiInputBase-input": {
    fontSize: "16px",
    fontWeight: "300",
    lineHeight: "1",
    color: "#2C2C2E",
    padding: "14px 20px",
  },
  "& fieldset": {
    border: "none",
  },
}));
const CustomHead = styled(Typography)(() => ({
  fontSize: "26px",
  fontWeight: "600",
  lineHeight: "1.445",
  color: "#1085AB",
  "@media (max-width: 575px)": {
    fontSize: "22px",
  },
}));





// -------------------------------------------- With rename field -------------------------------------------- 

// import React, { useEffect, useState } from "react";
// import { useFieldArray, useForm } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
// import * as yup from "yup";
// import { Box, Button, IconButton, styled, TextField, Typography } from "@mui/material";
// import { useCriticalActivitiesMutation, useFetchCoreActivityQuery, useRenameCoreFocusAreaMutation } from "../../../services/roleReviewService";
// import useAuth from "../../../hooks/useAuth";
// import { Link, useParams } from "react-router-dom";
// import { jwtDecode } from "jwt-decode";
// import EditIcon from '@mui/icons-material/Edit';
// const ErrorText = styled("div")`
//   color: red;
//   font-size: 12px;
//   margin-top: 4px;
// `;
// const validationSchema = yup.object().shape({
//   coreFocusAreas: yup
//     .array()
//     .of(
//       yup.object().shape({
//         subData: yup
//           .array()
//           .of(
//             yup.object().shape({
//               subTask: yup.string().required("Subtask is required"),
//               timeSpent: yup
//                 .number()
//                 .typeError("Time Spent must be a valid number")
//                 .min(0, "Must be at least 0")
//                 .max(100, "Cannot exceed 100")
//                 .required("Time Spent is required"),
//             })
//           )
//           .required("At least one Subtask is required"),
//       })
//     )
//     .required("Core Focus Areas are required"),
// });

// const Step3 = ({ currentStep, onPrev, formData ,onNext, onUpdate}) => {
//   const { users } = useAuth();
//   const [editingId, setEditingId] = useState(null);
//   const [editValue, setEditValue] = useState("");
//   const [renameCoreFocusArea] = useRenameCoreFocusAreaMutation();
  
//   // const userId = useParams();
//   // const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
//   // const [isJwtUser, setIsJwtUser] = useState(false);
  
//   const { id: param } = useParams();
  
//   const [employeeId, setEmployeeId] = useState(null);
//     useEffect(() => {
//       if (users?.role === "manager") {
//         if (param.includes(".")) {
//           try {
//             const decoded = jwtDecode(param); // Decode JWT token
//             setEmployeeId(decoded?.user_id);
//             // setIsJwtUser(true);  // Set employeeId in state
//             console.log(decoded?.user_id); // Extract user ID from token
//           } catch (error) {
//             console.error("Invalid token:", error);
//             setEmployeeId(null);
//           }
//         } else {
//           setEmployeeId(param);
//           // setIsJwtUser(false);  // If not a token, use the param as employee ID
//         }
//       } else {
//         setEmployeeId(users?.user_id); // Use logged-in user ID for non-managers
//       }
//     }, [users, param]);
//   console.log("employeeId",employeeId)
 
//   // const navigate = useNavigate();
//   const [createCriticalActivity] = useCriticalActivitiesMutation();
//   const { data: fetchedActivities,refetch:fetchactivitiesdata} = useFetchCoreActivityQuery(employeeId);

//   const handleEditClick = (field) => {
//     setEditingId(field.dbId); // Use dbId instead of field.id
//     setEditValue(field.area);
//   };

  
//   const handleSave = async (fieldId, index) => {
//     try {
//       const payload = { id: fieldId, new_area: editValue };
//       await renameCoreFocusArea(payload);

//       // --- THIS IS THE KEY CHANGE ---

//       // 1. Get the current values from the form
//       const currentFormValues = getValues();
//       console.log(currentFormValues,"currentFormValues")

//       // 2. Create a new array with the updated area name
//       const updatedCoreFocusAreas = currentFormValues.coreFocusAreas.map((area, i) => {
//         if (i === index) {
//           return { ...area, area: editValue };
//         }
//         return area;
//       });

//       // 3. Call the parent's update function with the new data
//       if (onUpdate) {
//         onUpdate({ coreFocusAreas: updatedCoreFocusAreas });
//       }

//       // --- END OF KEY CHANGE ---
      
//       // You can keep this, as it ensures react-hook-form's internal state is also in sync
//       setValue(`coreFocusAreas.${index}.area`, editValue);
//       setEditingId(null);

//     } catch (error) {
//       console.error("Failed to rename core focus area:", error);
//     }
//   };
//   const handleCancel = () => {
//     setEditingId(null);
//     setEditValue("");
//   };
//   useEffect(() => {
//     if (employeeId) {
//       fetchactivitiesdata();
//       console.log("fetchedActivities", fetchedActivities);
//     } else {
//       console.warn("Employee ID is not set. Cannot fetch activities.");
//     }
//   }, [employeeId, fetchactivitiesdata, fetchedActivities]);
// const processedFormData = {
//     ...formData,
//     coreFocusAreas: formData.coreFocusAreas.map((focusArea) => {
//       const relatedActivities = fetchedActivities?.data?.filter(
//         (activity) => activity.core_focus_area_id === focusArea.id
//       );

//       return {
//         ...focusArea,
//         dbId: focusArea.id, // <-- HERE: Create a new property 'dbId' to store the real ID
//         subData: relatedActivities?.length > 0
//           ? relatedActivities.map((activity) => ({
//               subTask: activity.area || "",
//               timeSpent: activity.importance || ""
//             }))
//           : [
//               { subTask: "", timeSpent: "" },
//               { subTask: "", timeSpent: "" },
//               { subTask: "", timeSpent: "" },
//             ]
//       };
//     })
//   };
//   // const processedFormData = {
//   //   ...formData,
//   //   coreFocusAreas: formData.coreFocusAreas.map((focusArea) => {
//   //     // Find all activities related to the current coreFocusArea
//   //     const relatedActivities = fetchedActivities?.data?.filter(
//   //       (activity) => activity.core_focus_area_id === focusArea.id
//   //     );

//   //     // If related activities exist, map them to subData; otherwise, set empty fields
//   //     return {
//   //       ...focusArea,
//   //       subData: relatedActivities?.length > 0
//   //         ? relatedActivities.map((activity) => ({
//   //             subTask: activity.area || "",  // Setting the "area" as "subTask"
//   //             timeSpent: activity.importance || "" // Setting "importance" as "timeSpent"
//   //           }))
//   //         :  [
//   //           { subTask: "", timeSpent: "" },
//   //           { subTask: "", timeSpent: "" },
//   //           { subTask: "", timeSpent: "" },
//   //         ] // Default empty subtask if no related activity
//   //     };
//   //   })
//   // };
  

//   const {
//     register,
//     handleSubmit,
//     control,
//     watch,
//     getValues,
//     setValue,
//     formState: { errors },
//   } = useForm({
//     mode: "onChange",
//     defaultValues: processedFormData,
//     resolver: yupResolver(validationSchema),
//   });

//   // Define useFieldArray for coreFocusAreas
//   const { fields: coreFocusFields, update: updateCoreFocusArea } = useFieldArray({
//     control,
//     name: "coreFocusAreas",
//   });
//   useEffect(() => {
//     // We iterate over the 'fields' array from useFieldArray, NOT the data from getValues.
//     // This gives us access to the special internal 'id' of each item.
//     coreFocusFields.forEach((field, index) => {
//       // Get the corresponding area from the parent component's props.
//       const propArea = formData.coreFocusAreas[index];

//       // Check if both exist and if the names are different.
//       if (field && propArea && field.area !== propArea.area) {
        
//         // 1. CRITICAL: Create the updated item by spreading the 'field' object.
//         //    This preserves the special 'id' ('62edb7eb-...') and all other data
//         //    like the user's input in 'subData'.
//         const updatedItem = { ...field, area: propArea.area };

//         // 2. Call the update function. Because we preserved the special 'id',
//         //    react-hook-form knows exactly which item to update and will
//         //    now correctly trigger a re-render.
//         updateCoreFocusArea(index, updatedItem);
//       }
//     });
//     // The dependencies should include the arrays we are comparing.
//   }, [formData.coreFocusAreas, coreFocusFields, updateCoreFocusArea]);
// //   useEffect(() => {
// //     // We need to re-calculate the processed form data here because `formData` has changed.
// //     const updatedProcessedData = {
// //         ...formData,
// //         coreFocusAreas: formData.coreFocusAreas.map((focusArea) => {
// //             const relatedActivities = fetchedActivities?.data?.filter(
// //                 (activity) => activity.core_focus_area_id === focusArea.id
// //             );

// //             return {
// //                 ...focusArea,
// //                 dbId: focusArea.id,
// //                 subData: relatedActivities?.length > 0
// //                     ? relatedActivities.map((activity) => ({
// //                         subTask: activity.area || "",
// //                         timeSpent: activity.importance || ""
// //                     }))
// //                     : [
// //                         { subTask: "", timeSpent: "" },
// //                         { subTask: "", timeSpent: "" },
// //                         { subTask: "", timeSpent: "" },
// //                     ]
// //             };
// //         })
// //     };

// //     // `reset` updates the entire form's values and will cause useFieldArray to get new fields.
// //     reset(updatedProcessedData);

// // }, [formData, fetchedActivities, reset]);
//   useEffect(() => {
//     if (fetchedActivities?.data) {
//       console.log("Fetched Activities:", fetchedActivities.data);
  
//       const focusAreaMap = {};
  
//       fetchedActivities.data.forEach((activity) => {
//         const focusAreaIndex = formData.coreFocusAreas.findIndex(
//           (focusArea) => focusArea.id === activity.core_focus_area_id
//         );
  
//         if (focusAreaIndex >= 0) {
//           if (!focusAreaMap[focusAreaIndex]) {
//             focusAreaMap[focusAreaIndex] = [];
//           }
//           focusAreaMap[focusAreaIndex].push({
//             subTask: activity.area,
//             timeSpent: activity.importance,
//           });
//         }
//       });
  
//       Object.keys(focusAreaMap).forEach((index) => {
//         // Set only if no prefilled data exists
//         if (!focusAreaMap[index] || focusAreaMap[index].length === 0) {
//           focusAreaMap[index] = [
//             { subTask: "", timeSpent: "" },
//             { subTask: "", timeSpent: "" },
//             { subTask: "", timeSpent: "" },
//           ];
//         }
//         setValue(`coreFocusAreas.${index}.subData`, focusAreaMap[index]);
//       });
  
//       // Handle cases where coreFocusAreas have no activities and no prefilled data
//       formData.coreFocusAreas.forEach((focusArea, index) => {
//         const existingSubData = watch(`coreFocusAreas.${index}.subData`);
//         if (!existingSubData || existingSubData.length === 0) {
//           setValue(`coreFocusAreas.${index}.subData`, [
//             { subTask: "", timeSpent: "" },
//             { subTask: "", timeSpent: "" },
//             { subTask: "", timeSpent: "" },
//           ]);
//         }
//       });
//     }
//   }, [fetchedActivities, formData.coreFocusAreas, setValue, watch]);
  
  
//   const onSubmit =async (data) => {
//     let areaExceeds100 = false;

//     coreFocusFields.forEach((field, index) => {
//       const subTasks = getValues(`coreFocusAreas.${index}.subData`);
//       const totalTimeForArea = subTasks.reduce(
//         (subAcc, subTask) => subAcc + (Number(subTask.timeSpent) || 0),
//         0
//       );

//       if (totalTimeForArea > 100) {
//         //Alert message removed
//         areaExceeds100 = true; //Set the flag to true
//       }
//       if (totalTimeForArea < 100) {
//         //Alert message removed
//         areaExceeds100 = true; //Set the flag to true
//       }
//     });

//     if (areaExceeds100) {
//       // Do not submit the form if there are any validation errors or if an area exceeds 100%
//       return;
//     }
//   // if (isSubmitDisabled) return;
//     try { 
      
//       const payload = data.coreFocusAreas.flatMap(focusArea =>
//               focusArea.subData.map(subTask => ({
//                 user_id: employeeId,
//                 core_focus_area_id: focusArea.dbId,
//                 area: subTask.subTask,
//                 importance: subTask.timeSpent,
//               }))
//             );
      
//       await createCriticalActivity(payload);
      
//       // console.log("Role review created successfully:", response);
//       onNext(); // Proceed to the next step
//     } catch (error) {
//       console.error("Failed to create role review:", error);
//       // Handle error (e.g., show an error message to the user)
//     }

//     // onNext();
//   };
//   const saveDataToBackend = async (data) => {
//     const transformedData = data.coreFocusAreas.flatMap((focusArea) =>
//       focusArea.subData.map((subTask) => ({
//         user_id: employeeId,
//         core_focus_area_id: focusArea.id,
//         area: subTask.subTask,
//         importance: subTask.timeSpent,
//       }))
//     );
  
//     try {
//       await createCriticalActivity(transformedData);
//       console.log("Data saved successfully to backend");
//     } catch (error) {
//       console.error("Error saving data:", error);
//     }
//   };
//   const handlePrevious = async (data) => {
//     try {
//       await saveDataToBackend(data);
//       onPrev(); // Move to the previous step after saving data
//     } catch (error) {
//       console.error("Error saving data before going back:", error);
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit(onSubmit)}>
//       <FormMiddleBoxWrap
//         sx={{
//           paddingTop: "30px",
//           paddingBottom: "0px",
//           marginBottom: "0",
//           boxShadow: "0",
//           position: "relative",
//           zIndex: "1",
//         }}
//       >
//         <RowWrap>
//           <Col12Wrap>
//             <CustomHead>
//              What are the critical activities that happen within each of the core focus areas you defined?
//             </CustomHead>
//             <FormLabelWrap
//                     sx={{
//                       fontSize: "20px",
//                       color: "#7C7C7C",
//                       letterSpacing: "0.3px",
//                       marginBottom: "0px",
//                     }}
//                   >
//                   Now please list, in order of importance, the critical activities that make up each core focus area listed below.Be sure that each “core focus area” totals to 100%. We’re looking for how your time in that segment of work is allocated. 
//                   </FormLabelWrap>
//                   <FormLabelWrap
//                     sx={{
//                       fontSize: "20px",
//                       color: "#7C7C7C",
//                       letterSpacing: "0.3px",
//                       marginBottom: "10px",
//                     }}
//                   >
//                     If needed, there is a short video to guide you.{" "}
//                     <Link
//                       to="https://youtu.be/MauV2Ui6arQ"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       sx={{ color: "#1976d2", textDecoration: "underline", fontWeight: "bold" }}
//                     >
//                       Click here to watch video
//                     </Link>
//                   </FormLabelWrap>
//           </Col12Wrap>
//         </RowWrap>
//       </FormMiddleBoxWrap>

//       {coreFocusFields.map((field, index) => {
//         // Define useFieldArray for each subData dynamically
//         // eslint-disable-next-line react-hooks/rules-of-hooks
//         const { fields: subFields, append: appendSubtask, remove: removeSubtask } = useFieldArray({
//           control,
//           name: `coreFocusAreas.${index}.subData`,
//         });

//         const totalTime = watch(`coreFocusAreas.${index}.subData`, []).reduce(
//           (acc, subTask) => acc + Number(subTask.timeSpent || 0),
//           0
//         );
//         console.log("Field at index", index, field.dbId);

//         return (
//           <FormMiddleBoxWrap key={field.id} sx={{ paddingTop: "30px", paddingBottom: "50px" }}>
//             <RowWrap>
//               <Col12Wrap>
//                 {/* <FormLabelWrap>{field.area}</FormLabelWrap> */}
//                 {editingId === field.dbId ? (
//                   <Box sx={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: '13px' }}>
//                     <CustomTextField
//                       value={editValue}
//                       onChange={(e) => setEditValue(e.target.value)}
//                       placeholder="Edit focus area name"
//                     />
//                     <CustomBtn
//                       type="button"
//                       onClick={() => handleSave(field.dbId,index)}
//                       sx={{  maxWidth: "80px", background: "#4CAF50", padding: "8px 12px", fontSize: '16px' }}
//                     >
//                       Save
//                     </CustomBtn>
//                     <CustomBtn
//                       type="button"
//                       onClick={handleCancel}
//                       sx={{maxWidth: "80px", background: "#9E9E9E", padding: "8px 12px", fontSize: '16px' }}
//                     >
//                       Cancel
//                     </CustomBtn>
//                   </Box>
//                 ) : (
//                   <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                     {console.log(field,"fieldfield")}
//                     <FormLabelWrap>{field.area}</FormLabelWrap>
//                     <IconButton
//                       onClick={() => handleEditClick(field)}
//                       sx={{
//                         p: 0, // remove padding
//                         mb: 1,
//                         color: "#1976d2", // icon color
//                         '&:hover': {
//                           backgroundColor: 'rgba(25, 118, 210, 0.1)' // subtle hover effect
//                         }
//                       }}
//                     >
//                       <EditIcon fontSize="small" />
//                     </IconButton>
//                   </Box>
//                 )}


//                 {subFields.map((subField, subIndex) => (
//                   <Box
//                     key={subField.id}
//                     sx={{
//                       display: "flex",
//                       flexWrap: "wrap",
//                       alignItems: "flex-start",
//                       columnGap: "10px",
//                       marginBottom: "10px",
//                       position: "relative",
//                     }}
//                   >
//                     <Box width={{ width: "calc(100% - 120px)" }}>
//                       <CustomTextField
//                         sx={{
//                           "& .MuiInputBase-input": {
//                             padding: "10px 20px",
//                           },
//                         }}
//                         variant="outlined"
//                         {...register(`coreFocusAreas.${index}.subData.${subIndex}.subTask`)}
//                         placeholder="Subtask"
//                       />
//                       {errors?.coreFocusAreas?.[index]?.subData?.[subIndex]?.subTask && (
//                         <ErrorText>
//                           {errors?.coreFocusAreas?.[index]?.subData?.[subIndex]?.subTask?.message}
//                         </ErrorText>
//                       )}
//                     </Box>
//                     <Box sx={{ width: "100px" }}>
//                       <CustomTextField
//                         sx={{
//                           "& .MuiInputBase-input": {
//                             padding: "10px 20px",
//                           },
//                         }}
//                         variant="outlined"
//                         {...register(`coreFocusAreas.${index}.subData.${subIndex}.timeSpent`)}
//                         placeholder="Time (%)"
//                       />
//                       {errors?.coreFocusAreas?.[index]?.subData?.[subIndex]?.timeSpent && (
//                         <ErrorText>
//                           {errors?.coreFocusAreas?.[index]?.subData?.[subIndex]?.timeSpent?.message}
//                         </ErrorText>
//                       )}
//                     </Box>
//                     <Box sx={{ width: "100px", display: "flex", justifyContent: "center" }}>
//                       <CustomBtn
//                         type="button"
//                         onClick={() => removeSubtask(subIndex)}
//                         variant="outlined"
//                         sx={{
//                           fontSize: "5px",
//                           fontWeight: "600",
//                           color: "#E75B5B",
//                           borderColor: "#F0F0F0",
//                           borderRadius: "7px",
//                           background: "#F0F0F0",
//                           position: "absolute",
//                           top: "9px",
//                           right: "-30px",
//                           width: "25px",
//                           height: "25px",
//                           minWidth: "0",
//                           padding: "6px",
//                           "& svg": {
//                             margin: "0",
//                           },
//                         }}
//                       >
//                         <svg
//                           width="16"
//                           height="16"
//                           viewBox="0 0 16 16"
//                           fill="none"
//                           xmlns="http://www.w3.org/2000/svg"
//                         >
//                           <path
//                             d="M1 1L15 15M15 1L1 15"
//                             stroke="#E75B5B"
//                             strokeWidth="2"
//                             strokeLinecap="round"
//                           />
//                         </svg>
//                       </CustomBtn>
//                     </Box>
//                   </Box>
//                 ))}
//                 <Box
//                   sx={{
//                     display: "flex",
//                     flexWrap: "wrap",
//                     alignItems: "center",
//                     columnGap: "10px",
//                     marginBottom: "10px",
//                   }}
//                 >
//                   <Box width={{ width: "calc(100% - 120px)" }}>
//                     <CustomBtn
//                       type="button"
//                       onClick={() => appendSubtask({ subTask: "", timeSpent: "" })}
//                       variant="outlined"
//                       sx={{
//                         fontSize: "14px",
//                         fontWeight: "600",
//                         color: "#1085AB",
//                         borderColor: "#F0F0F0",
//                         borderRadius: "7px",
//                         background: "#F0F0F0",
//                         maxWidth: "90px",
//                         padding: "10px 10px",
//                         "& svg": {
//                           marginRight: "8px",
//                         },
//                       }}
//                     >
//                       <svg
//                         width="16"
//                         height="16"
//                         viewBox="0 0 16 16"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           d="M8.10767 1L8.10767 15"
//                           stroke="#F28021"
//                           strokeWidth="2"
//                           strokeLinecap="round"
//                         />
//                         <path
//                           d="M1 8.18335L15 8.18335"
//                           stroke="#F28021"
//                           strokeWidth="2"
//                           strokeLinecap="round"
//                         />
//                       </svg>
//                       Add 
//                     </CustomBtn>
//                   </Box>
//                   <Box sx={{ width: "100px" }}>
//                        <FormLabelWrap
//                         sx={{
//                           fontSize: "16px",
//                           fontWeight: "500",
//                           textAlign: "center",
//                           marginBottom: "0",
//                         }}
//                       >
//                         {totalTime}%
//                         {totalTime > 100 && (
//   <ErrorText>Total percentage cannot exceed 100%!</ErrorText>
// )}
// {totalTime < 100 && (
//   <ErrorText>Total percentage cannot under 100%!</ErrorText>
// )}
//                       </FormLabelWrap>
//                     </Box>
//                 </Box>
//               </Col12Wrap>
//             </RowWrap>
//           </FormMiddleBoxWrap>
//         );
//       })}
//       <FormBtnBoxWrap>
//            <RowWrap>
//              <Col12Wrap sx={{ textAlign: "center" }}>
//               <CustomBtn
//             type="button"
//             variant="outlined"
//             sx={{
//               marginRight: "10px", // Add spacing between buttons
//               "& svg": { marginRight: "10px" },
//             }}
//             onClick={() => handlePrevious(getValues())} // Call the onPrev function on click
//           >
//             <svg
//               width="15"
//               height="16"
//               viewBox="0 0 15 16"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 d="M14 7C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9L14 7ZM0.292893 8.70711C-0.0976311 8.31658 -0.097631 7.68342 0.292893 7.29289L6.65685 0.928932C7.04738 0.538407 7.68054 0.538407 8.07107 0.928932C8.46159 1.31946 8.46159 1.95262 8.07107 2.34315L2.41421 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292893 8.70711ZM14 9L1 9L1 7L14 7L14 9Z"
//                 fill="white"
//               />
//             </svg>
//             Previous
//           </CustomBtn>
//               <CustomBtn
//               type="submit"
//               variant="outlined"
              
//               sx={{ "& svg": { 
//                 marginLeft: "10px" 
//               },
             
              
            
//             }}
             
//             >
//               Next
//               <svg
//                 width="15"
//                 height="16"
//                 viewBox="0 0 15 16"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   d="M1 7C0.447715 7 -4.82823e-08 7.44772 0 8C4.82823e-08 8.55228 0.447715 9 1 9L1 7ZM14.7071 8.70711C15.0976 8.31658 15.0976 7.68342 14.7071 7.29289L8.34315 0.928932C7.95262 0.538407 7.31946 0.538407 6.92893 0.928932C6.53841 1.31946 6.53841 1.95262 6.92893 2.34315L12.5858 8L6.92893 13.6569C6.53841 14.0474 6.53841 14.6805 6.92893 15.0711C7.31946 15.4616 7.95262 15.4616 8.34315 15.0711L14.7071 8.70711ZM1 9L14 9L14 7L1 7L1 9Z"
//                   fill="white"
//                 />
//               </svg>
//             </CustomBtn>
//             </Col12Wrap>
//           </RowWrap>
//         </FormBtnBoxWrap>
//     </form>
//   );
// };

// export default Step3;

// const RowWrap = styled(Box)(() => ({
//   display: "flex",
//   flexWrap: "wrap",
//   marginLeft: "-15px",
//   marginRight: "-15px",
// }));
// const Col12Wrap = styled(Box)(() => ({
//   flex: "0 0 auto",
//   width: "100%",
//   maxWidth: "100%",
//   paddingLeft: "15px",
//   paddingRight: "15px",
// }));
// const FormMiddleBoxWrap = styled(Box)(() => ({
//   padding: "50px 150px",
//   background: "#ffffff",
//   maxWidth: "1030px",
//   marginLeft: "auto",
//   marginRight: "auto",
//   marginBottom: "16px",
//   boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
//   "@media (max-width: 1199px)": {
//     maxWidth: "100%",
//     paddingLeft: "100px",
//     paddingRight: "100px",
//   },
//   "@media (max-width: 991px)": {
//     paddingLeft: "50px",
//     paddingRight: "50px",
//   },
//   "@media (max-width: 575px)": {
//     paddingLeft: "15px",
//     paddingRight: "15px",
//   },
// }));
// const FormBtnBoxWrap = styled(Box)(() => ({
//   maxWidth: "1030px",
//   marginLeft: "auto",
//   marginRight: "auto",
//   marginTop: "30px",
//   "@media (max-width: 1199px)": {
//     maxWidth: "100%",
//   },
// }));
// const FormLabelWrap = styled(Typography)(() => ({
//   fontSize: "20px",
//   fontWeight: "500",
//   lineHeight: "1.445",
//   color: "#000000",
//   marginBottom: "10px",
// }));
// const CustomBtn = styled(Button)(() => ({
//   width: "100%",
//   fontSize: "22px",
//   fontWeight: "400",
//   lineHeight: "1",
//   color: "#ffffff",
//   textTransform: "capitalize",
//   background: "#F28021",
//   borderColor: "#F28021",
//   borderRadius: "10px",
//   // padding: "19px 20px",
//   // maxWidth: "300px",
//   maxWidth: "150px",
//   padding: "10px 15px",
//   boxShadow: "none !important",
// }));
// const CustomTextField = styled(TextField)(() => ({
//   width: "100%",
//   border: "1px solid #DADADA",
//   borderRadius: "7px",
//   "& .MuiInputBase-input": {
//     fontSize: "16px",
//     fontWeight: "300",
//     lineHeight: "1",
//     color: "#2C2C2E",
//     padding: "14px 20px",
//   },
//   "& fieldset": {
//     border: "none",
//   },
// }));
// const CustomHead = styled(Typography)(() => ({
//   fontSize: "26px",
//   fontWeight: "600",
//   lineHeight: "1.445",
//   color: "#1085AB",
//   "@media (max-width: 575px)": {
//     fontSize: "22px",
//   },
// }));


// -------------------------------------------- With rename field -------------------------------------------- 




